/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAllowanceDto } from '../models/CreateAllowanceDto';
import type { ImportAllowanceDto } from '../models/ImportAllowanceDto';
import type { RemoveAllowanceDto } from '../models/RemoveAllowanceDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AllowanceService {
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static createAllowance(
        requestBody: CreateAllowanceDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allowance',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static removeAllowance(
        requestBody: RemoveAllowanceDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/allowance',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param apy
     * @param offset
     * @param limit
     * @param account
     * @param createdAtFrom
     * @param createdAtTo
     * @returns any
     * @throws ApiError
     */
    public static listAllowances(
        apy: number,
        offset?: number,
        limit: number = 10,
        account?: string,
        createdAtFrom?: number,
        createdAtTo?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allowance/list',
            query: {
                'offset': offset,
                'limit': limit,
                'account': account,
                'apy': apy,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
            },
        });
    }
    /**
     * @param apy
     * @param account
     * @returns any
     * @throws ApiError
     */
    public static isExistallowance(
        apy: number,
        account: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/allowance/isExist',
            query: {
                'apy': apy,
                'account': account,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static importAllowance(
        requestBody: ImportAllowanceDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/allowance/import_allowance',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
